import { render, staticRenderFns } from "./TimeControl.vue?vue&type=template&id=7c836da8"
import script from "./TimeControl.vue?vue&type=script&lang=ts"
export * from "./TimeControl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports